import React from "react";
import { COMPANY } from "../lib/data";

export default function WhatsAppFloat() {
  const url = `https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent(
    "Hello Alex Interiors, I'd like to discuss a commercial interior project."
  )}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-30 animate-ping" />
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] shadow-[0_12px_36px_rgba(37,211,102,0.45)] hover:scale-110 transition-transform duration-300">
        <svg viewBox="0 0 32 32" className="w-7 h-7 fill-white">
          <path d="M19.11 17.51c-.27-.14-1.61-.79-1.86-.88-.25-.09-.43-.14-.61.14-.18.27-.69.88-.85 1.06-.16.18-.31.2-.58.07-.27-.14-1.14-.42-2.17-1.34-.8-.71-1.34-1.6-1.5-1.87-.16-.27-.02-.42.12-.55.12-.12.27-.31.41-.47.14-.16.18-.27.27-.45.09-.18.05-.34-.02-.47-.07-.14-.61-1.47-.84-2.01-.22-.53-.45-.46-.61-.47l-.52-.01c-.18 0-.47.07-.71.34-.25.27-.94.92-.94 2.24 0 1.32.96 2.6 1.1 2.78.14.18 1.89 2.88 4.58 4.04.64.28 1.13.45 1.52.57.64.2 1.22.17 1.68.1.51-.08 1.61-.66 1.84-1.29.23-.63.23-1.18.16-1.29-.07-.11-.25-.18-.52-.32zM16.02 5.33c-5.94 0-10.78 4.84-10.78 10.78 0 1.9.5 3.76 1.45 5.39L5.2 26.67l5.32-1.39a10.74 10.74 0 0 0 5.5 1.5h.01c5.94 0 10.78-4.84 10.78-10.78 0-2.88-1.12-5.59-3.16-7.62a10.71 10.71 0 0 0-7.63-3.05zm0 19.66h-.01a8.92 8.92 0 0 1-4.55-1.25l-.32-.19-3.16.83.84-3.08-.21-.32a8.95 8.95 0 0 1-1.37-4.77c0-4.93 4.01-8.94 8.95-8.94a8.93 8.93 0 0 1 8.95 8.95c-.01 4.93-4.02 8.77-9.12 8.77z" />
        </svg>
      </span>
    </a>
  );
}
